import { toast } from "react-toastify"
import ApiService from "../../services/apiService"
import { useRef, useEffect, useState } from "react"
import ProgressBar from "./ProgressBar"
import { Button } from "reactstrap"
import P1 from './Water_irrigation_Version03/P1.svg'
import P2 from './Water_irrigation_Version03/P2.svg'
import P3 from './Water_irrigation_Version03/P3.svg'
import P4 from './Water_irrigation_Version03/P3.svg'
import P1_Red from './Water_irrigation_Version03/P2_R.svg'
import P1_Green from './Water_irrigation_Version03/P2_R.svg'
import P5 from './version03/Water_irrigation_Version03/P4.svg'
import { useAppSelector } from "../../reduxToolkit/hooks"


const ValveComponent = ({ data, index, chackData }: { data: any, index: any ,chackData?: any;}) => {


  const progressInterval = useRef<NodeJS.Timeout | null>(null);
  const [now, setNow] = useState<number>(0)
  const elapsedRef = useRef<number>(0);
  const intervalId = useRef<NodeJS.Timeout | null>(null)
  const hasStoredResponse = useRef<boolean>(false);
  const firstResponseRef = useRef<number>(0);
  const lastResponseRef = useRef<number>(0);
  const [progressBar, setProgressBar] = useState<boolean>(false)
  const [firstResponse, setFirstResponse] = useState<number>()
  const [lastResponse, setLastResponse] = useState<number>()
  const [ValveIndex, setValveIndex] = useState<string | any>()
  const role = useAppSelector((state: any) => state.role.role);
  let line1Index = 0;
  let line2Index = 0;

  console.log(chackData);
  const redImages = [
    null,
    P1_Red,
    P1_Red,
    P1_Red,
    P1_Red
  ];

  const greenImages = [
    null,
    P1_Green,
    P1_Green,
    P1_Green,
    P1_Green
  ]



  const valveNum = parseInt(data.valveNumber?.match(/\d+/)?.[0] || "0", 10);
  let sov = `SOV ${valveNum}`





  const stopProgressBar = () => {
    if (progressInterval.current) {
      clearInterval(progressInterval.current);
      progressInterval.current = null;
    }
    setNow(100); // ✅ response milte hi turant 100%
    setTimeout(() => {
      setNow(0);
      setProgressBar(false);
    }, 300); // thoda visual pause taaki 100% dikh jaye

  };

  const startProgressBar = () => {
    if (progressInterval.current) {
      clearInterval(progressInterval.current);
      progressInterval.current = null;
    }

    setNow(0);
    setProgressBar(true);

    const stepTime = 250;
    const duration = 35000;
    const capPercent = 95;
    const increment = capPercent / (duration / stepTime);

    let current = 0;

    progressInterval.current = setInterval(() => {
      current += increment;
      if (current >= 100) {
        current = 100;
        clearInterval(progressInterval.current!);
        progressInterval.current = null;
      }
      setNow(current);
    }, stepTime);
  };

  const sendSovCommand = async () => {
    try {
      const res = await ApiService.axiosApi("/command/sov/open/close", {
        method: "POST",
        data: {
          chakId: data.chakId,
          sovNo: Number(sov.replace("SOV ", "")),
          open_Close: data.on ? 0 : 1,
        },
      });

      if (res.success) {
        toast.success(`${data.on ? "Valve Close" : "Valve Open"}`);
      } else {
        toast.error("failed. please retry again");
      }
    } catch (e) {
      console.error("error in sov open close:", e);

    } finally {
      stopProgressBar();
    }
  };


  const handleClick = () =>{
    if(role !== 'Administrator') return;

    if (chackData.romsAuto) {
      console.log(chackData);
      startProgressBar();
      sendSovCommand();
    } else {
      toast.error("Please select manual mode");
    }


  }



  const Pole = [
    P1,
    P1,
    P2,
    P3,
    P4
  ]
  let imageElement = null;

  const imageIndex = index * 1 + 1
  const imgSrc = data.valveOn ? greenImages[imageIndex] : redImages[imageIndex] || P1_Red;






  imageElement = (
    <>
      <img
        key={data.id}
        id={`P${imageIndex}`}
        src={Pole[imageIndex]}
        alt="" />

      <button
        onClick={handleClick}

        id={`P${imageIndex}_Red`}
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '50px',
          top: '10px',
          marginLeft: '5px',
          padding: '0px',
          zIndex: 10,
          backgroundColor: 'transparent',
          border: 'none',
          outline: 'none',
          position: 'absolute',
          cursor: role === 'Administrator' ? 'pointer' : 'not-allowed',
        }}
        className={data.valveNumber}
        disabled={role !== 'Administrator'}
      ></button>

      <img
        key={data.id}
        id={`P${imageIndex}_Red`}
        src={imgSrc || P1_Red}
        alt=""
        style={{ pointerEvents: 'none' }}
      />



    </>
  );





  return (

    <>

      {progressBar && <ProgressBar totalpage={0} pageNumber={0}
        now={now}
        mystyle={{
          position: 'absolute',
          height: '25px',
          zIndex: 1000,
          backgroundColor: 'whitesmoke',
          borderRadius: '4px',
          width: '1136px',
          marginLeft: '203px',
          bottom: '477px'
        }} />}




      {imageElement}



      { /*data.map((valve: any, index: any) => {

        if (['V01', 'V03', 'V05', 'V07', 'V09', 'V11', 'V13'].includes(valve.valveNumber)) {

          const imageIndex = line1Index * 2 + 1; // 1, 3, 5, 7...
          const imgSrc = valve.on ? greenImages[imageIndex] : redImages[imageIndex] || V2_Red; // fallback if index out of range

          const offsetX = line1Index * 0;
          const offsetY = line1Index * 0;

          line1Index++;

          return (

            <>

              <img

                key={valve.id}
                id={`V${imageIndex}_Red`}
                src={imgSrc || V1_Red}
                alt=""
              />

              <button
               onClick={() => {



                  changeSov();

                console.log(valve.valveNumber)
              }}
                  id={`V${imageIndex}_Red`}
                  style={{width:'40px',
                    height:'40px',
                    borderRadius:'50px' ,top:'10px',
                     marginLeft:'5    px',
                      padding:'0px',
                      zIndex:10,
                      backgroundColor:'transparent',
                      border:'none',
                      outline:'none'
                    }}
                  className={valve.valveNumber}
              >

              </button>

            </>

          );
        } else {
          const imageIndex = line2Index * 2 + 2; // 2, 4, 6, ...
          const imgSrc = valve.on ? greenImages[imageIndex] : redImages[imageIndex] || V2_Red;

          const offsetX = line2Index * 0;
          const offsetY = line2Index * 0;

          line2Index++;
          return (
            <>
            <img

              key={valve.id}
              id={`V${imageIndex}_Red`}
              src={imgSrc || V1_Red}


              alt=""
            />
                <button
                   onClick={() => {
                      changeSov();
                      console.log(valve.valveNumber)
                   }}
                  id={`V${imageIndex}_Red`}

                  style={{width:'40px',
                    height:'40px',
                    borderRadius:'50px' ,
                    top:'10px',
                    marginLeft:'35px',
                     padding:'0px',
                     zIndex:10,
                     backgroundColor:'transparent',
                     border:'none',
                     outline:'none'
                    }}

                  className={valve.valveNumber}
              >

              </button>
            </>

          );
        }

      }) */}

    </>
  )
}

export default ValveComponent;
